<template>
	<div class="column">
		<Header></Header>
		<div class="colunm_main_box">
			<el-breadcrumb
				class="column_top_nav"
				separator-class="el-icon-arrow-right"
				style="font-size:14px;"
			>
				<span style="float:left;">当前位置：</span>
				<el-breadcrumb-item :to="{ path: '/' }"
					>首页</el-breadcrumb-item
				>
				<el-breadcrumb-item
					v-for="(item, index) in location"
					:key="index"
				>
					<span v-if="index != location.length - 1">{{ item }}</span>
					<span v-if="index == location.length - 1" class="active">{{
						item
					}}</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="column_center_box">
				<!-- 左侧导航 -->
				<div class="column_l_nav_box">
					<h5 class="column_l_nav_title">{{ topTitle }}</h5>
					<el-menu
						:default-active="currentChoose"
						:unique-opened="true"
						active-text-color="#4EAC41!important"
						class="el-menu-vertical-demo"
						@select="selectMenu"
						style="border-right:none;"
					>
						<div v-for="(item, index) in navData" :key="index">
							<el-submenu
								v-if="item.childrenList.length > 0"
								:index="item.uid"
								class="column_l_nav_item"
							>
								<template slot="title">
									<span
										@click="selectMenu2(item.uid)"
										style="width:100%;height:100%;display:block;"
										:style="
											currentChoose == item.uid
												? 'color:rgb(78, 172, 65)'
												: ''
										"
										class="column_l_nav_style1"
										>{{ item.title_name }}</span
									>
								</template>
								<el-menu-item-group>
									<el-menu-item
										v-if="sitem.childrenList.length <= 0"
										v-for="(sitem, i) in item.childrenList"
										:key="i"
										:index="sitem.uid + ''"
										class="column_l_nav_style2"
										>. {{ sitem.title_name }}</el-menu-item
									>

									<el-submenu
										v-if="sitem.childrenList.length > 0"
										v-for="(sitem, i) in item.childrenList"
										:key="i"
										:index="sitem.uid + ''"
										class="column_l_nav_style2"
									>
										<template slot="title"
											>. {{ sitem.title_name }}</template
										>
										<el-menu-item
											v-if="
												ssitem.childrenList.length <= 0
											"
											v-for="(ssitem,
											j) in sitem.childrenList"
											:key="j"
											:index="ssitem.uid + ''"
											class="column_l_nav_style3"
											>.
											{{ ssitem.title_name }}
										</el-menu-item>
										<el-submenu
											v-if="
												ssitem.childrenList.length > 0
											"
											v-for="(ssitem,
											s) in sitem.childrenList"
											:key="s"
											:index="ssitem.uid + ''"
											class="column_l_nav_style2"
										>
											<template slot="title"
												>.
												{{
													ssitem.title_name
												}}</template
											>
											<el-menu-item
												v-if="
													sssitem.childrenList
														.length <= 0
												"
												v-for="(sssitem,
												d) in ssitem.childrenList"
												:key="d"
												:index="sssitem.uid + ''"
												class="column_l_nav_style3"
												>.
												{{ sssitem.title_name }}
											</el-menu-item>
										</el-submenu>
									</el-submenu>
								</el-menu-item-group>
							</el-submenu>
							<el-menu-item
								v-if="item.childrenList.length <= 0"
								:index="item.uid"
								class="column_l_nav_item"
							>
								<span
									slot="title"
									class="column_l_nav_style1"
									>{{ item.title_name }}</span
								>
							</el-menu-item>
							<h6
								v-if="item.remark == '首页3'"
								class="column_l_nav_title2"
							>
								热门精选
							</h6>
						</div>
						<!-- <el-menu-item index="2" class="column_l_nav_item">
                            <span slot="title" class="column_l_nav_style1">国内政策</span>
                        </el-menu-item>-->
					</el-menu>
					<img
						class="column_l_nav_img"
						src="../../assets/main/navbg.png"
						alt=""
					/>
				</div>
				<!-- 右侧显示部分 -->
				<div class="column_r_box">
					<!-- 默认mode2 showType后台数据1是默认，2是碳排放，3是国际概览 -->
					<Mode2
						v-if="currentModel == '2'"
						:currentChoose="currentChoose"
					></Mode2>
					<Mode1
						v-if="currentModel == '3'"
						:currentChoose="currentChoose"
					></Mode1>
					<Mode3
						v-if="
							currentModel == '1-0' ||
								currentModel == '1-1' ||
								currentModel == '1-2' ||
								currentModel == '1-4'
						"
						:currentChoose="currentChoose"
						:currentModel="currentModel"
					></Mode3>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';
import Mode1 from '@/components/mode1'; //饼图+实现搜索+列表
import Mode2 from '@/components/mode2'; //普通二级页
import Mode3 from '@/components/mode3'; //国际概览+多条件搜索
import titlebg from '@/assets/main/titlebg.png';

export default {
	props: {},
	components: {
		Header,
		Footer,
		Mode1,
		Mode2,
		Mode3,
	},
	data() {
		return {
			navData: [], //导航栏数据
			navData2: [], //特殊的6个栏目多请求一个导航栏数据
			topTitle: '二级栏目', //左侧导航头部标题
			currentChoose: '', //当前选中的栏目uid
			currentModel: '', //当前调用的模板1-0/1-1/1-2:国际概览,2:默认,3:碳排放
			location: [], //获取位置数据
			urlName: magic.getUrlKey('name'), //获取url的参数name
		};
	},
	computed: {},
	created() {
		let _name = magic.getUrlKey('name'); //获取url的参数name
		_name ? (this.topTitle = _name) : (this.topTitle = '二级栏目');

		let _uid = magic.getUrlKey('uid'); //获取url的参数uid
		_uid ? (this.currentChoose = _uid) : '';
		// //console.log(this.urlName,'urlName');
	},
	mounted() {
		$('.column_l_nav_item .el-submenu__title').css({
			'font-size': '18px',
			color: '#8C8C8C',
		});
		setTimeout(() => {
			$('.column_l_nav_title').css(
				'background',
				"url('" + titlebg + "') no-repeat center"
			);
		}, 500);

		let _id = magic.getUrlKey('id'); //获取url的参数id
		_id ? this.fetchNavList(_id) : (widnow.location.href = '/index.html');

		let _name = magic.getUrlKey('name'); //获取url的参数name

		this.fetchLoaction(_id);
	},
	methods: {
		//获取导航数据
		fetchLoaction(_id) {
			let _this = this;
			api.getMenu(_id).then((res) => {
				_this.location = res.data.reverse();
			});
		},
		//点击带有子节点的menu选项
		selectMenu2(uid) {
			//console.log(uid, 'test uid2');
			// return;
			let _this = this;
			for (let i = 0; i < _this.navData.length; i++) {
				//console.log(_this.navData, uid, 'res444');
				if (_this.navData[i].uid == uid) {
					_this.currentModel = _this.navData[i].showType;
					_this.currentChoose = uid;
					//console.log(_this.currentModel, 'res111');
				} else {
					if (_this.navData[i].childrenList.length > 0) {
						for (
							let j = 0;
							j < _this.navData[i].childrenList.length;
							j++
						) {
							if (_this.navData[i].childrenList[j].uid == uid) {
								_this.currentModel =
									_this.navData[i].childrenList[j].showType;
								_this.currentChoose = uid;
								//console.log(_this.currentModel, 'res222');
							} else {
								if (
									_this.navData[i].childrenList[j]
										.childrenList.length > 0
								) {
									for (
										let k = 0;
										k <
										_this.navData[i].childrenList[j]
											.childrenList.length;
										k++
									) {
										if (
											_this.navData[i].childrenList[j]
												.childrenList[k].uid == uid
										) {
											_this.currentModel =
												_this.navData[i].childrenList[
													j
												].childrenList[k].showType;
											_this.currentChoose = uid;
											//console.log(
											//_this.currentModel,
											//'res333'
											//);
										}
									}
								}
							}
						}
					}
				}
			}
		},
		//点击选择menu栏目
		selectMenu(uid) {
			if (uid == 'A620999') {
				this.currentChoose = '';
				window.open('#/actionPlan?id=9&name=实施方案&uid=1', '_blank');
				return;
			}
			if (uid == 'A621999') {
				this.currentChoose = '';
				window.open(
					'#/hotColumn?id=231&name=热点专题&uid=7392',
					'_blank'
				);
				return;
			}
			// return;
			let _this = this;
			for (let i = 0; i < _this.navData.length; i++) {
				//console.log(_this.navData, uid, 'res444');
				if (_this.navData[i].uid == uid) {
					_this.currentModel = _this.navData[i].showType;
					_this.currentChoose = uid;
					//console.log(_this.currentModel, 'res111');
				} else {
					if (_this.navData[i].childrenList.length > 0) {
						for (
							let j = 0;
							j < _this.navData[i].childrenList.length;
							j++
						) {
							if (_this.navData[i].childrenList[j].uid == uid) {
								_this.currentModel =
									_this.navData[i].childrenList[j].showType;
								_this.currentChoose = uid;
								//console.log(_this.currentModel, 'res222');
							} else {
								if (
									_this.navData[i].childrenList[j]
										.childrenList.length > 0
								) {
									for (
										let k = 0;
										k <
										_this.navData[i].childrenList[j]
											.childrenList.length;
										k++
									) {
										if (
											_this.navData[i].childrenList[j]
												.childrenList[k].uid == uid
										) {
											_this.currentModel =
												_this.navData[i].childrenList[
													j
												].childrenList[k].showType;
											_this.currentChoose = uid;
										} else {
											if (
												_this.navData[i].childrenList[j]
													.childrenList[k]
													.childrenList.length > 0
											) {
												for (
													let index = 0;
													index <
													_this.navData[i]
														.childrenList[j]
														.childrenList[k]
														.childrenList.length;
													index++
												) {
													const element =
														_this.navData[i]
															.childrenList[j]
															.childrenList[k]
															.childrenList[
															index
														];
													if (element.uid == uid) {
														_this.currentModel =
															element.showType;
														_this.currentChoose = uid;
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		//获取导航数据
		fetchNavList(_id) {
			let _this = this;

			api.getNavList(_id).then((res) => {
				_this.navData = [];
				// _this.navData = res.data;
				//如果是传入id和导航id相等并且父id为74那么左侧挡寒就应该只有一个值
				let flag = res.data.some(
					(item) =>
						item.id == _id &&
						item.parent_id == 74 &&
						item.childrenList.length <= 0
				);
				if (flag) {
					for (let index = 0; index < res.data.length; index++) {
						const element = res.data[index];
						if (
							element.id == _id &&
							element.parent_id == 74 &&
							element.childrenList.length <= 0
						) {
							_this.navData.push(element);
						}
						//如果是一级栏目
					}
				} else {
					_this.navData = res.data;
				}

				console.log(flag, '_this.navData _this.navData _this.navData ');
				if (res.data.length > 0) {
					let _uid = magic.getUrlKey('uid'); //获取url的参数uid
					let _showType = magic.getUrlKey('showType'); //获取url的参数showType
					//console.log(_uid, _showType, 'test');
					if (!_uid) {
						//没有UID就默认选中第一个

						if (res.data[0].childrenList.length > 0) {
							if (
								res.data[0].childrenList[0].childrenList
									.length > 0
							) {
								_this.currentChoose =
									res.data[0].childrenList[0].childrenList[0].uid;
								_this.currentModel =
									res.data[0].childrenList[0].childrenList[0].showType;
							} else {
								_this.currentChoose =
									res.data[0].childrenList[0].uid;
								_this.currentModel =
									res.data[0].childrenList[0].showType;
							}
							//console.log(
							//_this.currentModel,
							//'_this.currentModel1'
							//);
						} else {
							_this.currentChoose = res.data[0].uid;
							_this.currentModel = res.data[0].showType;
							//console.log(
							//_this.currentModel,
							//'_this.currentModel2'
							//);
						}
					} else {
						if (_showType != null) {
							//点击政策速递一级的进入页面显示
							_this.currentModel = _showType;
							_this.currentChoose = _uid;
							//console.log(
							//_this.currentModel,
							//'_this.currentModel5'
							//);
						} else {
							for (let i = 0; i < res.data.length; i++) {
								if (res.data[i].uid == _uid) {
									_this.currentModel = res.data[i].showType;
									_this.currentChoose = _uid;
									//console.log(
									//_this.currentModel,
									//'_this.currentModel3'
									//);
								} else {
									if (res.data[i].childrenList.length > 0) {
										for (
											let j = 0;
											j < res.data[i].childrenList.length;
											j++
										) {
											if (
												res.data[i].childrenList[j]
													.uid == _uid
											) {
												_this.currentModel =
													res.data[i].childrenList[
														j
													].showType;
												_this.currentChoose = _uid;
												//console.log(
												//_this.currentModel,
												//'_this.currentModel4'
												//);
											}
										}
									}
								}
							}
						}
					}
				}
			});
		},
	},
};
</script>
<style scoped lang="less">
.column {
	width: 100%;
	/* height: 100vh; */
	background: #f2f2f2;
}
.colunm_main_box {
	width: 1300px;
	margin: 0 auto;
	min-height: 600px;
}
.column_top_nav {
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1a1a1a;
	line-height: 26px;
	height: 54px;
	line-height: 54px;
}
.column_top_nav .active {
	color: #4eac41;
}
.column_center_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 50px;
}
// 左侧导航部分
.column_l_nav_box {
	float: left;
	width: 260px;
	// min-height: 460px;
	padding: 20px;
	background: #fff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
	position: relative;
	padding-bottom: 232px;
}
.column_l_nav_title {
	width: 260px;
	height: 50px;
	text-align: center;
	line-height: 50px;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #f7f7f7;
	background: url('../../assets/main/titlebg.png') no-repeat center;
	background-size: cover;
	margin-bottom: 20px;
}
.column_l_nav_title2 {
	width: 260px;
	height: 50px;
	line-height: 50px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #439238;
	margin-bottom: 10px;
	margin-top: 10px;
	border-bottom: 1px solid #439238;
	font-size: 16px;
	text-align: center;
}
.column_l_nav_item {
	background: #f2f2f2;
	margin-bottom: 8px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
}
.column_l_nav_img {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
.column_l_nav_style1 {
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	// color: #3F433F;
}
.column_l_nav_style2 {
	border-bottom: 1px solid #f3f3f3;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #8c8c8c;
}
.column_l_nav_style3 {
	font-size: 13px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
}
.column_l_nav_style3:hover {
	color: #4eac41;
}

// 右侧显示部分
.column_r_box {
	float: right;
	width: 950px;
	// padding:14px 30px;
	min-height: 578px;
	// background: #FFFFFF;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/view/column/index.vue